import React from "react";
import ProductionOrderSapDetail from "../../../components/user/productionOrderSap/productionOrderSapDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const DetailProductionOrderSapPage = () => {
  let { uuid } = useParams();
  return (
    <Layout
      body={
        <>
          <ProductionOrderSapDetail uuid={uuid} />
        </>
      }
    />
  );
};

DetailProductionOrderSapPage.propTypes = {};

export default DetailProductionOrderSapPage;
